import { Injectable } from "@angular/core";
import { AuthenticatedHttpService } from './authenticatedhttp.service';
import { Observable, BehaviorSubject } from 'rxjs';

import { QuoteInfoService } from "./quote-info.service";
import { AdjustmentService } from "./adjustments.service";

import { PricingHeader } from '../model/pricing-header';
import { QuoteSummary } from "../model/quote-summary";
import { Adjustment } from '../model/adjustment';

@Injectable()
export class QuoteSummaryService {
    private baseUrl;
    emailModalStatus: BehaviorSubject<boolean> = new BehaviorSubject(true);
    private _quoteSummaryCache: QuoteSummary;

    constructor(
        private _http: AuthenticatedHttpService,
        private quoteInfoService: QuoteInfoService,
		private adjustmentService: AdjustmentService
	) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    getPricingHeader(quoteId): Observable<PricingHeader> {
        return this._http.get(`${this.baseUrl}/api/quotesummary/pricingheader/${quoteId}`)
            .map(x => {
                let pricingHeader: PricingHeader = x.json();
                pricingHeader.AdjustmentInfo = this.adjustmentService.mapAdjustments(pricingHeader.AdjustmentInfo);
                return pricingHeader;
            }).do((response) => {
                let qs = new QuoteSummary();
                qs.CustomerName = response.CustomerName;
                qs.ModelName = response.ModelName;
                qs.BaseCost = response.BaseCost;
                qs.OptionsTotal = response.OptionsTotal;
                qs.Dues = response.Dues;
                qs.GrandTotal = response.GrandTotal;
                qs.Transportation = response.Transportation;
                qs.Surcharge = response.Surcharge;
                qs.ModelBaseOverride = response.ModelBaseOverride;
                qs.ModelBaseCost = response.ModelBaseCost;
                qs.DuesOnly = response.DuesOnly;
                qs.VIPAmount = response.VIPDiscountAmount;
                qs.PartnerAssistanceAmount = response.PartnerAssistanceAmount;
                this._quoteSummaryCache = qs;
                if (response.ModelBaseOverride > 0) { qs.BaseCost = response.ModelBaseOverride; }
                this.quoteInfoService.adjustment$.next(response.AdjustmentInfo);
                this.quoteInfoService.quoteSummary$.next(qs);
            })
            .finally(() => {
                this.calculatePrices();
            })
            .catch(this._http.handleError);
    }

    calculatePrices() {
        let qs = new QuoteSummary();
        let adjustment = this.quoteInfoService.adjustment$.value;
        if (adjustment === null || adjustment === undefined && this.quoteInfoService.currentPricingView$.value === 1) {
            adjustment = new Adjustment();
            adjustment.baseAdjustmentPercent = 70.00;
            adjustment.optionsAdjustmentPercent = undefined;
        }

        if (this._quoteSummaryCache !== undefined && this._quoteSummaryCache !== null) {
            if (this.quoteInfoService.currentPricingView$.value === 1 && adjustment !== undefined && adjustment !== null) {
                qs.BaseCost = (adjustment.baseAdjustmentPercent !== undefined && adjustment.baseAdjustmentPercent !== 0)
                    ? (this._quoteSummaryCache.BaseCost * (1 + (adjustment.baseAdjustmentPercent / 100)))
                    : (this._quoteSummaryCache.BaseCost + adjustment.baseAdjustmentFlat);
                qs.OptionsTotal = (adjustment.optionsAdjustmentPercent !== undefined)
                    ? (this._quoteSummaryCache.OptionsTotal * (1 + (adjustment.optionsAdjustmentPercent / 100)))
                    : this._quoteSummaryCache.OptionsTotal;
                qs.Dues = this._quoteSummaryCache.Dues;
                qs.VIPAmount = this._quoteSummaryCache.VIPAmount;
                qs.PartnerAssistanceAmount = this._quoteSummaryCache.PartnerAssistanceAmount;
                qs.GrandTotal = qs.BaseCost + qs.OptionsTotal + qs.Dues + qs.PartnerAssistanceAmount + qs.VIPAmount;
            } else {
                qs.BaseCost = this._quoteSummaryCache.BaseCost;
                qs.ModelBaseOverride = this._quoteSummaryCache.ModelBaseOverride;
                qs.ModelBaseCost = this._quoteSummaryCache.ModelBaseCost;
                if (qs.ModelBaseOverride > 0) { qs.BaseCost = qs.ModelBaseOverride; }
                qs.OptionsTotal = this._quoteSummaryCache.OptionsTotal;
                qs.Dues = this._quoteSummaryCache.Dues;
                qs.GrandTotal = this._quoteSummaryCache.BaseCost + this._quoteSummaryCache.OptionsTotal + this._quoteSummaryCache.Dues;
            }
            qs.DuesOnly = this._quoteSummaryCache.DuesOnly;
            qs.Transportation = this._quoteSummaryCache.Transportation;
            qs.CustomerName = this.quoteInfoService.quoteSummary$.value.CustomerName;
            qs.ModelName = this.quoteInfoService.quoteSummary$.value.ModelName;
            qs.ModelBaseCost = this.quoteInfoService.quoteSummary$.value.ModelBaseCost;
            qs.ModelBaseOverride = this.quoteInfoService.quoteSummary$.value.ModelBaseOverride;
            this.quoteInfoService.quoteSummary$.next(qs);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/quote-summary.service.ts